import { render, staticRenderFns } from "./ServidorEdit.vue?vue&type=template&id=e54c251e&scoped=true&"
import script from "./ServidorEdit.vue?vue&type=script&lang=js&"
export * from "./ServidorEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e54c251e",
  null
  
)

export default component.exports